/** Schritt 3 „KI-Bewertung“. */
const wizJudgDE = {
  wizJudgTitle: 'Wie soll die KI Kandidaten bewerten?',
  wizJudgSkipTitle: 'Ohne KI-Bewertung – alle Kandidaten ansprechen',
  wizJudgSkipDesc:
    'Für eigene Suchen und Projektlisten, in denen du die Kandidaten schon selbst ausgewählt hast. Gesperrte, anderswo schon kontaktierte und Kandidaten mit unklarem Geschlecht bleiben trotzdem aus.',
  wizJudgSkipSubtitle: 'Alle geladenen Kandidaten werden angesprochen – die KI bewertet sie nicht.',
  wizJudgSkipKept:
    'Deine Kriterien bleiben gespeichert. Schaltest du die Bewertung wieder ein, bewertet die KI mit ihnen.',
  wizJudgSubtitle:
    'Starte mit einer Vorlage oder lass sie aus dem Briefing erstellen und passe sie für Deine Stelle an. Bitte beachte: je mehr Kriterien du hinzufügst, desto weniger Kandidaten wird SAIA für dich finden können.',
  wizJudgTemplate: 'Vorlage',
  wizJudgTemplatePlaceholder: 'Vorlage wählen',
  wizJudgModified: 'angepasst',
  wizJudgFromBriefing: 'Neu aus dem Briefing erstellen',
  wizJudgFromBriefingName: 'Aus dem Briefing erstellt',
  wizJudgFromBriefingBusy: 'SAIA erstellt die Kriterien …',
  wizJudgFromBriefingError: 'Die Kriterien konnten nicht erstellt werden.',
  wizJudgTemplatesLoading: 'Vorlagen werden geladen …',
  wizJudgTemplatesError: 'Die Vorlagen konnten nicht geladen werden.',
  wizJudgSave: 'Als Vorlage speichern',
  wizJudgSaved: 'Für das Team gespeichert',
  wizJudgSaveError: 'Die Vorlage konnte nicht gespeichert werden.',
  wizJudgMust: 'Muss',
  wizJudgMustHint: 'Belegt oder klar wahrscheinlich → Klasse A, nicht eindeutig belegt → Klasse B',
  wizJudgNice: 'Wünschenswert',
  wizJudgNiceHint: 'Wird in der Begründung erwähnt, ändert die Klasse nicht',
  wizJudgExcl: 'Ausschluss',
  wizJudgExclHint: 'Trifft eins klar zu → Klasse C, wird nicht angesprochen',
  wizJudgAddCriterion: '+ Kriterium',
  wizJudgCriterionPlaceholder: 'Kriterium + Enter',
  wizJudgClassesTitle: 'Welche Kandidaten sprechen wir an?',
  wizJudgClassesSubtitle:
    'Die KI sortiert jedes Profil in Klasse A, B oder C: A erfüllt die Muss-Kriterien, B ist nicht eindeutig belegt, aber ohne Ausschluss, bei C trifft ein Ausschlusskriterium zu.',
  wizJudgClassA: 'A. Muss-Kriterien erfüllt, passt zur Stelle',
  wizJudgClassADesc: 'Im Profil belegt oder aus Rollen und Erfahrung klar wahrscheinlich',
  wizJudgClassB: 'B. Grundsätzlich geeignet, Muss-Kriterien nicht eindeutig belegt',
  wizJudgClassBDesc:
    'Passt grundsätzlich zur Stelle, die Muss-Kriterien sind aber nicht (voll) im Profil belegt',
  wizJudgClassC: 'C. No-Go trifft zu oder nicht geeignet für die Stelle',
  wizJudgClassCDesc: 'Wird nicht angesprochen',
  wizJudgClassCLocked: 'Nicht wählbar: Diese Kandidaten werden nie angesprochen.',
  wizJudgTemplatesNone:
    'Noch keine Vorlagen. Speichere Kriterien als Vorlage, um sie wiederzuverwenden.',
  wizJudgSaveTitle: 'Als Vorlage speichern',
  wizJudgSaveName: 'Name der Vorlage',
  wizJudgSaveTeam: 'Für das Team',
  wizJudgSaveOwn: 'Nur für mich',
  wizJudgSaveOverwrite: 'Eine Vorlage mit diesem Namen existiert schon und wird überschrieben.',
  wizJudgSaveCancel: 'Abbrechen',
  wizJudgSaveConfirm: 'Speichern',
  wizJudgSaveBusy: 'Wird gespeichert …',
  wizJudgSaveNameEmpty: 'Bitte einen Namen eingeben.',
  wizJudgSavedOwn: 'Nur für dich gespeichert',
};
export default wizJudgDE;
